import React from 'react';

import MyNavbar from '../../../components/general/mynavbar/MyNavbar';

import CategoryPage from '../../../subscreens/customer/category/categorypage/CategoryPage';
import Footer from '../../../components/general/footer/Footer';
import useScrollToTop from "../../../contexts/UseScrolltoTop";


const CPPage=()=>{
     useScrollToTop();
    return(
        <>
        <MyNavbar />  
        <CategoryPage />
        <Footer /> 
     </>
    );

}
export default CPPage;